import { Longhand } from "../longhand.js";
export default Longhand.fromKeywords({ inherits: true }, "collapse", "discard", "preserve", "preserve-breaks", "preserve-spaces", "break-spaces");
//# sourceMappingURL=white-space-collapse.js.map